import React, { Component } from 'react'
import { Box, Text } from '@chakra-ui/react'
import { withRouter } from 'react-router-dom'
import { Form, Field } from 'react-final-form'
import { injectIntl, FormattedMessage } from 'react-intl'

import intlMessages from '../translations'
import withToast from 'src/components/Toast'
import Disclaimer from 'src/modals/Disclaimer'
import { Input } from 'src/components/Form'
import Button from 'src/components/Button/Button'
import intlMessagesApp from 'src/modules/App/translations'
import { Layout, Container, PageTitle } from 'src/components/Layout'

class AddDriver extends Component {
  state = {
    driver: {},
    error: false,
    showDisclaimer: false,
  }

  componentDidUpdate(prevProps) {
    const { intl, submitting, history, successful, toast } = this.props

    if (!submitting && prevProps.submitting && successful) {
      history.push('/changepolicy')
      toast({
        title: intl.formatMessage(intlMessages.changePolicyVehicleThankYouTitle),
        description: intl.formatMessage(intlMessages.changePolicyNotificationSuccess),
        status: 'success',
      })
    }

    if (!submitting && prevProps.submitting && !successful) {
      toast({
        message: intl.formatMessage(intlMessagesApp.appErrorTitle),
        description: intl.formatMessage(intlMessages.changePolicyNotificationError),
        status: 'error',
      })
    }
  }

  handleSubmit = values => {
    this.setState({
      driver: values,
      showDisclaimer: true,
    })
  }

  validateFormFields = values => {
    const { intl } = this.props
    const errors = {}

    if (!values.firstName) {
      errors.firstName = intl.formatMessage(intlMessages.documentAddDriverValidationFirstName)
    }
    if (!values.lastName) {
      errors.lastName = intl.formatMessage(intlMessages.documentAddDriverValidationLastName)
    }
    if (!values.driverLicense) {
      errors.driverLicense = intl.formatMessage(
        intlMessages.documentAddDriverValidationDriverLicense,
      )
    }
    if (!values.phone) {
      errors.phone = intl.formatMessage(intlMessages.documentAddDriverValidationPhone)
    }
    if (!values.address) {
      errors.address = intl.formatMessage(intlMessages.documentAddDriverValidationAddress)
    }

    return errors
  }

  handleCloseDisclaimer = () => {
    this.setState({
      showDisclaimer: false,
    })
  }

  handleSubmitDisclaimer = () => {
    const { addDriver, document } = this.props
    const { driver } = this.state
    const data = {
      ...driver,
      policyId: document.id,
      documentType: document.category || 'other',
    }

    addDriver(data)
  }

  // renderThankYou = (driver) => {

  //   let { countryIsoCode } = this.props;

  //   return (
  //     <div style={{ textAlign: "center" }}>
  //       <h2>
  //         <FormattedMessage
  //           id="app.document.addDriver.thankYou"
  //           defaultMessage="Thank you"
  //         />
  //       </h2>
  //       <p>
  //         {countryIsoCode && countryIsoCode.toLowerCase() === 'us' ? (
  //           <FormattedHTMLMessage
  //             id="app.document.addDriver.thankYou2US"
  //             defaultMessage="Your request to add <br /> {firstName} {lastName} as a driver on this vehicle has been sent to your agent"
  //             values={{
  //               firstName: driver.firstName,
  //               lastName: driver.lastName
  //             }}
  //           />
  //         ) : (
  //           <FormattedHTMLMessage
  //             id="app.document.addDriver.thankYou2"
  //             defaultMessage="Your request to add <br /> {firstName} {lastName} as a driver on this vehicle has been sent to your broker"
  //             values={{
  //               firstName: driver.firstName,
  //               lastName: driver.lastName
  //             }}
  //           />
  //         )}
  //       </p>
  //     </div>
  //   )
  // }

  renderForm = () => {
    const { intl } = this.props

    return (
      <Form
        onSubmit={this.handleSubmit}
        validate={this.validateFormFields}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Text fontWeight={500} variant='secondary' mt={'20px'} fontSize={'16px'}>
              <FormattedMessage
                id='app.document.addDriver.driverInfo'
                defaultMessage='Driver Info'
              />
            </Text>

            <Field
              name='firstName'
              render={({ input, meta }) => (
                <Box mt={'16px'} mb={'25px'}>
                  <Input
                    name='firstName'
                    error={meta}
                    placeholder={intl.formatMessage(intlMessages.documentAddDriverLabelFirstName)}
                    type='text'
                    {...input}
                  />
                </Box>
              )}
            />
            <Field
              name='lastName'
              render={({ input, meta }) => (
                <Box mt={'16px'} mb={'25px'}>
                  <Input
                    name='lastName'
                    error={meta}
                    placeholder={intl.formatMessage(intlMessages.documentAddDriverLabelLastName)}
                    type='text'
                    {...input}
                  />
                </Box>
              )}
            />
            <Field
              name='driverLicense'
              render={({ input, meta }) => (
                <Box mt={'16px'} mb={'25px'}>
                  <Input
                    name='driverLicense'
                    error={meta}
                    placeholder={intl.formatMessage(
                      intlMessages.documentAddDriverLabelDriverLicence,
                    )}
                    type='text'
                    {...input}
                  />
                </Box>
              )}
            />
            <Field
              name='phone'
              render={({ input, meta }) => (
                <Box mt={'16px'} mb={'25px'}>
                  <Input
                    name='phone'
                    error={meta}
                    placeholder={intl.formatMessage(intlMessages.documentAddDriverLabelPhone)}
                    type='tel'
                    {...input}
                  />
                </Box>
              )}
            />
            <Field
              name='address'
              render={({ input, meta }) => (
                <Box mt={'16px'} mb={'25px'}>
                  <Input
                    name='address'
                    error={meta}
                    placeholder={intl.formatMessage(intlMessages.documentAddDriverLabelAddress)}
                    type='text'
                    {...input}
                  />
                </Box>
              )}
            />

            <Button isFullWidth size='lg' type='submit'>
              <FormattedMessage id='app.document.addDriver.submit' defaultMessage='Submit' />
            </Button>
          </form>
        )}
      />
    )
  }

  render() {
    const { submitting, intl } = this.props
    const { showDisclaimer } = this.state

    return (
      <Layout>
        <PageTitle title={intl.formatMessage(intlMessages.documentAddDriverHeadline)} showBack />
        <Container padder className='global-centered-desktop-content'>
          {this.renderForm()}
          <Disclaimer
            visible={showDisclaimer}
            loading={submitting}
            skipAfterHoursCheck={true}
            onClose={this.handleCloseDisclaimer}
            onSubmit={this.handleSubmitDisclaimer}
          />
        </Container>
      </Layout>
    )
  }
}

export default withRouter(injectIntl(withToast(AddDriver)))
